import { Checkbox } from '@mui/material';

import { GDMInputCheckboxComponent } from './GDMInputCheckbox.type';

/* TODO: Implement component using GDM default design */
const GDMInputCheckbox: GDMInputCheckboxComponent = props => <Checkbox {...props} />;

export default GDMInputCheckbox;
